import React, { useState } from 'react';
import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import AutosuggestComponent from "../document/AutosuggestComponent";
import DocumentAffidavitIfConsentAndConformityToPPLCsContractualSavingsProgram from '../document/DocumentAffidavitIfConsentAndConformityToPPLCsContractualSavingsProgram';


function AffidavitIfConsentAndConformityToPPLCsContractualSavingsProgram() {
    const [applicantDetails, setApplicantDetails] = useState(null);
    const [loanProcessingDetails, setLoanProcessingDetails] = useState([]);


    return (
        <>
            <NavMain slug="affidavit-if-consent-and-conformity-to-pplcs-contractual-savings-program" parent="5" />
            <HeaderMain slug="affidavit-if-consent-and-conformity-to-pplcs-contractual-savings-program" />
            <div className="main-content documents">
                <AutosuggestComponent
                setApplicantDetails={setApplicantDetails}
                setLoanProcessingDetails={setLoanProcessingDetails}
                />
                <DocumentAffidavitIfConsentAndConformityToPPLCsContractualSavingsProgram
                    applicantDetails={applicantDetails}
                    loanProcessingDetails={loanProcessingDetails}
                />
            </div>
        </>
    );
}

export default AffidavitIfConsentAndConformityToPPLCsContractualSavingsProgram;